export default {
    View: "v",
    ViewSubordinateSheets: "vss",
    ViewOthers: "vo",
    ViewExpired: "ve",
    ViewDetails: "vd",
    Create: "c",
    Edit: "e",
    EditSubordinateSheets: "ess",
    Delete: "d",
    Archive: "a",
    Submit: "s",
    Move: "m",
    Renew: "r",
    ClearLock: "cl",
    Download: "dl",
    DownloadComparisonSheet: "dcs",
    SendForDocuSignApproval: "sc",
    Send: "sd",
    OverrideCustomerSigned: "ocs",
    OverrideIpsSigned: "ois",
    DealerView: "dv",
    SetOwner: "so",
    Void: "void",
    Resurrect: "ru",
    SetPhysicalDocumentSheetState: "sps",
    ReviewByDealer: "rd",
    ReviewByIps: "ri",
    RejectDeal: "rjd",
    MarkProductSchedule: "mps",
    MakeLive: "ml",
    SetMeterReading: "smr",
    SetMeterCode: "smc",
    IPSAdminEdit: "ip",
    DealerAdminEdit: "da",
    ImpersonateUser: "iu",
    Upload: "up",
    Approve: "ap",
    SubmitRequest: "sr",
    NonOwnedSubmitRequest: "nosr",
    CreateComparisonSnapshot: "ccs",
    ViewCrystallisedSheets: "vcs",
    CrystalliseAndUncrystalliseSheets: "cus",
    SetReadOnly: "ro",
    SetRewriteOnly: "rwo",
    ViewAllSheets: "vas",
    ViewLive: "vl",
    ArchiveAndUnarchiveSheets: "sarc",
    UpdateSheetScheduleReference: "ussn",
    Reset: "rt",
    PreApproveSupplier: "pasup",
    PreApproveIPS: "paips",
    ViewEnableCleaningMeter: "vecm",
    ViewEnableScanMeter: "vesm",
    ViewPaperSizeOption: "vpso",
    ViewTieredToner: "vtt",
    ViewLargeFormatPriceA: "vlfprca",
    ViewLargeFormatPriceB: "vlfprcb",
    ViewRateType: "vrt",
    ViewPaymentMethod: "vpm",
    ViewExcessAllocation: "vea",
    ViewRawNotificationText: "vrn",
    CanBulkTransferSheetOwnership: "btso",
    ViewIPSyndicateRates: "ipsrs",
    ViewScheduleSetup: "schsu",
    ViewCapitalCalc: "capc",
    ViewQuarterlyService: "quser",
    ViewCutSheetPaper: "csp",
    ViewStandardScheduleItems: "stschi",
    ViewLargeFormatSection: "lfsec",
    ViewScheduleStability: "schstb",
    UpdateIPSPermissions: "uip",
    CanEditAccountManagerCrmLogin: "amcl",
    LoginWithoutCRM: "lwc",
    UpdateIPSUsers: "uipusr",
    DuplicateToNewMaster: "dnm",
    DuplicateLive: "dlv",
    ViewAuditTrail: "vat",
    DownloadAuditTrail: "dat",
    Lock: "l",
    UpdateCreditAvailable: "uca",
    UpdateCRMRecord: "ucr",
    ViewDocumentRecipients: "vdr",
    DeleteAll: "dal",
    DeleteVoided: "dvd",
    ViewSettlementUpgradeField: "vsuf",
    DuplicateFromTemplate: "dft",
    CreateWithDetails: "cwd",
    EditOthers: "eo",
    EditAllSheets: "eas",
    ViewArchivedSheets: "varc",
    AllowMultipleSessionsInAmethyst: "ams",
    AllowMultipleSessionsInOpal: "amso",
};
